module.exports = __webpack_public_path__ + "img/symbol_6.ae539f99.png";